import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection, getFirestore, query, where } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import Button from "react-bootstrap/Button";
import { useMemo } from "react";
import { projectDocumentSchema } from "../types/firestore";
import { getFirestoreZodConverter } from "../modules/firestoreZodConverter";
import Create from "../components/projects/create";
import Card from "react-bootstrap/Card";
import roleNames from "../modules/roleNames";
import LoadingAlert from "../components/common/loadingAlert";

const auth = getAuth();
const firestore = getFirestore();

export default function Home() {
	const navigate = useNavigate();

	const [user, userLoading, userError] = useAuthState(auth);

	const projectsQuery = useMemo(
		() =>
			user &&
			query(
				collection(firestore, "Projects"),
				where("Members." + user.uid, "!=", null),
			).withConverter(getFirestoreZodConverter(projectDocumentSchema)),
		[user],
	);

	const [projectsSnapshot, , projectsSnapshotError] = useCollection(projectsQuery);

	return (
		<div>
			<div className="mb-2 w-100 d-flex justify-content-center">
				<img
					src="/img/logoDark.svg"
					height="60"
					className="d-inline-block align-top"
					alt="MasterGrill"
				/>
			</div>

			<hr />

			{userLoading || userError || (user && !projectsSnapshot) ? (
				<LoadingAlert error={userError || projectsSnapshotError} />
			) : !user || !projectsSnapshot ? (
				<Button variant="success" onClick={() => navigate("/account")}>
					Anmelden
				</Button>
			) : (
				<div>
					<div className="mb-2 fw-bold">Projektübersicht</div>
					<div className="d-grid gap-1">
						{projectsSnapshot.docs.map((doc) => (
							<Card
								role="button"
								key={doc.id}
								className="mb-2 clickable-card"
								onClick={() => navigate("/projects/" + doc.id)}>
								<Card.Body>
									<div>{doc.data().Name}</div>
									<small className="text-muted">{roleNames[doc.data().Members[user.uid]]}</small>
								</Card.Body>
							</Card>
						))}
					</div>
					<Create />
				</div>
			)}
		</div>
	);
}
